import { render, staticRenderFns } from "./batchProgress.vue?vue&type=template&id=4b54789d&"
import script from "./batchProgress.vue?vue&type=script&lang=js&"
export * from "./batchProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports